<template>
  <div class="tw:w-full tw:max-w-[1440px] tw:mx-auto tw:py-10 tw:px-8">
    <router-link to="/ds" class="tw:text-sm tw:opacity-60 tw:hover:opacity-100 tw:mb-4 tw:inline-flex tw:items-center tw:gap-1" style="color: var(--fontcolor); text-decoration: none;">
      <IconGoogle name="arrow_back" size="16px" color="var(--fontcolor)" /> Design System
    </router-link>
    <h1 class="tw:text-3xl tw:font-bold tw:mb-2 tw:mt-2">{{ title }}</h1>
    <p v-if="description" class="tw:text-sm tw:opacity-60 tw:mb-8">{{ description }}</p>
    <div v-else class="tw:mb-8" />
    <div class="tw:space-y-12">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IconGoogle } from '@/components/atomic'

defineProps<{
  title: string
  description?: string
}>()
</script>
